import { oteApi } from 'yxt-biz-pc/packages/api';

// 获取考试安排信息
export const getArrange = (id) => {
  return oteApi.get(`/arrange/${id}`);
};

// 获取考试安排基本信息
export const getArrangeBase = (id) => {
  return oteApi.get(`/arrange/${id}/base`);
};

// 新建考试安排基本信息
export const createArrange = (bodyObj) => {
  return oteApi.post('/arrange', bodyObj);
};

// 更新考试安排基本信息
export const updateArrange = (id, bodyObj) => {
  return oteApi.put(`/arrange/${id}`, bodyObj);
};

// 更新考试安排控制信息
export const updateArrangeControl = (id, bodyObj) => {
  return oteApi.put(`arrange/${id}/control`, bodyObj);
};

// 设置指定批阅人
export const setDesignMarker = (id, userIds) => {
  return oteApi.put(`/arrange/${id}/mark/design`, userIds);
};

// 设置批阅方式
export const setMarkMode = (id, markType) => {
  return oteApi.put(`/arrange/${id}/mark/mode`, markType);
};

// 获取批阅人和批阅方式
export const getExamMarker = (id) => {
  return oteApi.get(`/arrange/${id}/marker`);
};

// 创建第三方考试安排
export const externalArrangeCreate = (formDataAll, navCode, dataPermissionCode) => {
  return oteApi.post('/external/arrange' + `?navCode=${navCode || ''}&dataPermissionCode=${dataPermissionCode || ''}`, formDataAll);
};

// 更新第三方考试安排
export const externalArrangeUpdate = (arrangeId, formDataAll, navCode, dataPermissionCode) => {
  return oteApi.put(`/external/arrange/${arrangeId}` + `?navCode=${navCode || ''}&dataPermissionCode=${dataPermissionCode || ''}`, formDataAll);
};
